import colors from 'vuetify/lib/util/colors'
import Core from "@/modules/core/service/Core";
import Search from "@/modules/core/service/private/SearchRequest";

const Constants = {
    search: {
        minLength: 2,
    },
    url: {
        fields     : '/fields',
        count: {
            site    : '/site/count',
            incident: '/incident/count'
        },
        preferences: '/api/user/preferences'
    },
}

const state = {
    search: {
        field   : null,
        criteria: "",
        active  : true,
        liftmanagement: true,
        myCustomers   : true,
        idleUnits     : false
    },
    context    : {
        incident: null,
        site    : null
    },
    fields     : {},
    hitCount   : null,
    preferences: null,
    themes     : [
        {
            name   : "Standard",
            primary: '#0a68b8'
        },
        {
            name   : "Hundt",
            primary: '#9c021b'
        },
        {
            name   : "Teal",
            primary: colors.teal.base
        },
        {
            name   : "Indigo",
            primary: colors.indigo.base
        },
        {
            name   : "Grau",
            primary: colors.blueGrey.base
        },
        {
            name   : "Orange",
            primary: colors.deepOrange.base
        },
        {
            name   : "Kontrast",
            primary: '#000000'
        },
    ],

}

const mutations = {
    updateContext (state, payload) {
        state.context = payload;
    },

    updateSearch (state, payload) {
        state.search = payload;
    },

    updateFields (state, payload) {
        state.fields = payload;
    },

    updateIncidentFilter (state, payload) {
        state.preferences.onlyIdleIncidents= payload.onlyIdleIncidents;
        state.preferences.onlyMyCustomers= payload.onlyMyCustomers;
        state.preferences.onlyOpenIncidents= payload.onlyOpenIncidents;
        state.preferences.ignoreDeleted= payload.ignoreDeleted;
    },

    updateUnitFilter (state, payload) {
        state.preferences.onlyLiftmanagement= payload.onlyLiftmanagement;
        state.preferences.onlyMyCustomers= payload.onlyMyCustomers;
        state.preferences.onlyIdleUnits= payload.onlyIdleUnits;
        state.preferences.onlyLgSmartDevices= payload.onlyLgSmartDevices;
    },

    updateHitCount (state, payload) {
        state.hitCount = payload;
    },

    updatePreferences (state, payload) {
        state.preferences = payload;
    },

    updateUnitDownResolvedSince (state, payload) {
        state.preferences.unitDownResolvedSince = payload;
    }
}

const actions = {
    setSearch ( { commit }, payload) {
        commit('updateSearch', payload);
    },

    setContext ( { commit }, payload) {
        commit('updateContext', payload);
    },

    setIncidentFilter ( { commit }, payload) {
        commit('updateIncidentFilter', payload);
        return Core.method.put("/api/user/filter", payload);
    },

    setUnitFilter ( { commit }, payload) {
        commit('updateUnitFilter', payload);
    },

    getFields ( { commit }) {
        return Core.method.get(Search.url(Constants.url.fields)).then(data => {
            commit ('updateFields', data);
        })
    },

    countHits( { commit }, payload) {
        const url = payload.category === 'incident' ? Constants.url.count.incident : Constants.url.count.site;
        return Core.method.post(Search.url(url), Search.filter(payload.category, payload.filter)).then(data => {
            commit('updateHitCount', data.count);
        })
    },

    setUnitDownResolvedSince ({ commit }, payload) {
        commit('updateUnitDownResolvedSince', payload);
    },

    findPreferences ( { commit } ) {
        return Core.method.get(Constants.url.preferences).then(data => {
            commit ('updatePreferences', data);
        })
    },
}

const getters = {
    search: state => {
        return state.search;
    },

    context: state => {
        return state.context;
    },

    fields: state => {
        return state.fields;
    },

    hitCount: state => {
        return state.hitCount;
    },

    preferences: state => {
        return state.preferences;
    },

    themes: state => {
        return state.themes;
    },
}

const searchModule = {
    state,
    mutations,
    actions,
    getters
}

export default searchModule